import { createAsyncThunk } from "@reduxjs/toolkit";
import coreAPIs from "services/api/core";

export const getCoreClipDetails = createAsyncThunk("core/clip/getCoreClipDetails", async (payload) => {
  try {
    const response = await coreAPIs.getCoreClipDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getCoreClipsDetails = createAsyncThunk("core/clip/getCoreClipsDetails", async (payload) => {
  try {
    const response = await coreAPIs.getCoreClipsDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const cutCoreClip = createAsyncThunk("core/clip/cutCoreClip", async (payload) => {
  try {
    const response = await coreAPIs.cutCoreClip(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getMergeClipDetails = createAsyncThunk("core/clip/getMergeClipDetails", async (payload) => {
  try {
    const response = await coreAPIs.getMergeClipDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
